import { render, staticRenderFns } from "./addSubject.vue?vue&type=template&id=314d1278&"
import script from "./addSubject.vue?vue&type=script&lang=js&"
export * from "./addSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports